import { useState } from 'react'
import { Icon, IconButton } from '@vp/swan'
import MobileMenuSidebar from './MobileMenuSidebar'
import type { BrandItem, HeaderLink } from '../../../types/site-header'
import type { NavigationCategory } from '../../../types/navigation'
import { MyAccountResourcesContentProvider } from '@vp/my-account-pages-dropdown'
import { getHeaderTracker } from '../../../tracking'
import { TOP_NAV } from '../../../constants/analytics'
import { useI18n } from '../../../context/TranslationContext'
import useClient from '../../../hooks/useClient'

export interface MobileMenuProps {
  helpLink: HeaderLink
  myProjectsLink: HeaderLink
  navigationData: NavigationCategory[]
  locale: string
  brands: BrandItem[]
  brandsDesktop: BrandItem[]
  brandsHeading: string
  isRedesignedSignInButtonEnabled: boolean
}

export default function MobileMenu(props: MobileMenuProps) {
  const { locale, helpLink, myProjectsLink, navigationData, brands, brandsDesktop, brandsHeading, isRedesignedSignInButtonEnabled } = props
  const { translate } = useI18n()
  const isClient = useClient()
  const [showMenu, setShowMenu] = useState(false)
  const handleClose = () => setShowMenu(false)

  const handleMenuOpen = () => {
    getHeaderTracker().trackHeaderLink({
      subSection: TOP_NAV,
      navigationDetailPath: ['Hamburger'],
    })
    setShowMenu(true)
  }

  return (
    <>
      <IconButton tooltip={translate('menu.open')} skin="tertiary" onClick={handleMenuOpen} display="block" p={3}>
        <Icon iconType="menu" size="standard" aria-label={translate('menu.open')} />
      </IconButton>
      <MyAccountResourcesContentProvider>
        {isClient && (
          <MobileMenuSidebar
            {...{
              helpLink,
              myProjectsLink,
              navigationData,
              handleClose,
              brands,
              brandsDesktop,
              brandsHeading,
              isRedesignedSignInButtonEnabled,
              showMenu,
              locale,
            }}
          />
        )}
      </MyAccountResourcesContentProvider>
    </>
  )
}
